<template>
	<div>
		<div class="d-flex justify-space-between" v-if="asDetail == false">
			<div class="text-h5">Data Riwayat Stok Stockist</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listEwalletDetail" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationEwalletDetail.total_data" class="table-w-120">
				<template v-slot:item.ewallet_withdrawal_log_detail_balance="{ item }">
					{{ item.ewallet_withdrawal_log_detail_balance | toRupiah }}
				</template>
				<template v-slot:item.ewallet_withdrawal_log_detail_transfer="{ item }">
					{{ item.ewallet_withdrawal_log_detail_transfer | toRupiah }}
				</template>
				<template v-slot:item.ewallet_withdrawal_log_detail_admin="{ item }">
					{{ item.ewallet_withdrawal_log_detail_admin | toRupiah }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationEwalletDetail">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationEwalletDetail">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationEwalletDetail.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationEwalletDetail.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	props: {
		asDetail: {
			type: Boolean,
			default: false,
		},
		logID: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			sortBy: 'ewallet_withdrawal_log_detail_balance',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Kode Stockist', align: 'start', value: 'stockist_code'},
			{ text: 'Nama Stockist', value: 'stockist_name'},
			{ text: 'Nama Bank', value: 'ewallet_withdrawal_log_detail_bank_name'},
			{ text: 'Nomor Rekening', value: 'ewallet_withdrawal_log_detail_account_no'},
			{ text: 'Pemilik Rekening', value: 'ewallet_withdrawal_log_detail_account_name'},
			{ text: 'Total Dana', value: 'ewallet_withdrawal_log_detail_balance'},
			{ text: 'Biaya Admin', value: 'ewallet_withdrawal_log_detail_admin'},
			{ text: 'Total Transfer', value: 'ewallet_withdrawal_log_detail_transfer'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_code'
				}
			}, {
				type: 'text',
				label: 'Nama Stockist',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'stockist_name'
				}
			}, {
				type: 'text',
				label: 'Nama Rekening',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'ewallet_withdrawal_log_detail_account_name'
				}
			}, {
				type: 'text',
				label: 'Nomor Rekening',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'ewallet_withdrawal_log_detail_account_no'
				}
			},
			]
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceEwallet', ['listEwalletDetail', 'paginationEwalletDetail']),
	},
	methods: {
		...mapActions('ecommerceEwallet', ['getEwalletDetailWithdraw', 'exportEwalletDetailWithdraw']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceEwallet', ['clearDataStockist']),

		getData() {
			let params = this.params;
			let query = this.queryString({limit:this.limit, page: this.page, params: params, sort: this.sortBy, dir: this.sortDir})
			if (this.logID)
				query.withdrawal_log_id = this.logID
			this.getEwalletDetailWithdraw(query)
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			let params = this.params;
			let query = this.queryString({limit:this.limit, page: this.page, params: params, sort: this.sortBy, dir: this.sortDir})
			if (this.logID)
				query.withdrawal_log_id = this.logID
			this.exportEwalletDetailWithdraw(query)
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
	},
	beforeDestroy(){
		if (this.asDetail == false) {
			this.clearDataStockist()
		}
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
